'use strict';

/* global angular, Intercom */

const IntercomService = function ($document, $timeout, AppDialogsActions, AuthService, Flux, IdentityService) {

  let intercomAppId;
  /* PRIVATE METHODS */
  const toggleIntercomVisibilityClass = (state) => {
    const el = angular.element(document).find('body');
    const className = 'visible_chat';
    switch (state) {
    case 'show':
      if (!el.hasClass(className)) {
        el.addClass(className);
      }
      break;
    case 'hide':
      if (el.hasClass(className)) {
        el.removeClass(className);
      }
      break;
    }
  };

  /* PUBLIC METHODS */
  const init = () => {

    const initDataEl = $document[0].querySelector('#init-data');
    const initData = initDataEl && JSON.parse(initDataEl.getAttribute('value'));
    intercomAppId = initData.intercomAppId;
    this.shutdown();
    if (AuthService.isAuthenticated()) {
      this.boot();
    }
  };

  /**
  * Method used to open the Intercom chat initially
  */
  const boot = () => {

    if (AuthService.isAuthenticated()) {
      /**
      * Boot as User (not for dashboard)
      */
      const userObj = IdentityService.getUser();
      if (userObj.adminSession){
        console.warn('Logged in with adminSession - Not logging into intercom');
      }
      else {

        try {

          Intercom('boot', {
            app_id: intercomAppId, // Intercom ID
            email: userObj.email,
            isAdmin: userObj.isAdmin,
            name: `${userObj.firstName} ${userObj.lastName}`,
            user_id: userObj.id // Core User ID, not to be confused with Intercom's id
          });
        }
        catch (err) {

          console.warn('Failed to boot Intercom');
        }
      }
    }
    else {
      /*
      * Boot anonymous (not for dashboard)
      */
      $timeout(() => {

        Intercom('boot', {
          app_id: intercomAppId
        });
      }, 100);
    }
  };

  /**
  * Method used to update the Intercom user settings.  Note:
  *
  *  id is matched - the user_id and email will be updated if they are sent.
  *  user_id match - the email will be updated, the id is not updated.
  *  email match - the user_id will be set if the matching user does not have
  *
  */
  const update = (data) => {

    Intercom('update', data);
  };

  const show = () => {

    const PlanStore = Flux.Store.get('PlanStore');
    const userObj = IdentityService.getUser();
    if (!userObj.adminSession) {
      if (PlanStore.get('orgPlan').isEnabled) {
        if (PlanStore.checkFeature('organization', 'chat_support')) {
          Intercom('show');
          toggleIntercomVisibilityClass('show');
        }
        else {
          AppDialogsActions.NotSupportedInPlan.dispatch();
        }
      }
      else {
        AppDialogsActions.MustBePayingCustomer.dispatch();
      }
    }
    else {
      AppDialogsActions.DisabledForAdmins.dispatch();
    }
  };

  /**
  * Method used to close the Intercom chat
  */
  const hide = () => {

    const PlanStore = Flux.Store.get('PlanStore');
    if (PlanStore.checkFeature('organization', 'chat_support')) {
      Intercom('hide');
      toggleIntercomVisibilityClass('hide');
    }
    else {
      AppDialogsActions.NotSupportedInPlan.dispatch();
    }
  };

  /**
  * Method used on app logout to clear Intercom
  */
  const shutdown = () => {

    Intercom('shutdown');
  };

  /**
  * Method used to send a tracking event to Intercom
  *
  * param  {string} eventName: the event name
  * param  {object} data: meta data about the event
  */
  const trackEvent = (eventName, data) => {

    Intercom('trackEvent', eventName, data);
  };

  Object.assign(this, { init, boot, update, show, hide, shutdown, trackEvent});
};

module.exports = IntercomService;



// WEBPACK FOOTER //
// ./src/common/intercom/IntercomService.js